import React, { useState } from 'react';
import axios from 'axios';
import './ForgotPassword.css';

function ForgotPassword({ onBack, nightMode }) {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showResetForm, setShowResetForm] = useState(false);
  const [resetToken, setResetToken] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/forgot-password`, { email });
      setMessage(response.data.message);
      setShowResetForm(true);
    } catch (error) {
      setError(error.response?.data?.message || 'An error occurred');
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/reset-password`, { token: resetToken, newPassword });
      setMessage(response.data.message);
      setTimeout(() => onBack(), 3000); // Go back to login after 3 seconds
    } catch (error) {
      setError(error.response?.data?.message || 'An error occurred');
    }
  };

  return (
    <div className={`forgot-password-container ${nightMode ? 'night-mode' : ''}`}>
      <div className="forgot-password-content">
        <div className="forgot-password-box">
          <h1>Volleyball Score Tracker</h1>
          <h2>Reset Password</h2>
          {message && <p className="success-message">{message}</p>}
          {error && <p className="error-message">{error}</p>}
          {!showResetForm ? (
            <form onSubmit={handleForgotPassword}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
              <button type="submit" className="submit-btn">Send Reset Token</button>
            </form>
          ) : (
            <form onSubmit={handleResetPassword}>
              <input
                type="text"
                value={resetToken}
                onChange={(e) => setResetToken(e.target.value)}
                placeholder="Enter reset token"
                required
              />
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
                required
              />
              <button type="submit" className="submit-btn">Reset Password</button>
            </form>
          )}
          <div className="auth-options">
            <button onClick={onBack} className="back-button">Back to Login</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;